import React from 'react';
import Icon from '../../../components/AppIcon';

const DashboardStats = ({ stats }) => {
  const statCards = [
    {
      title: 'Total Transactions',
      value: stats?.totalTransactions,
      change: stats?.transactionChange,
      changeType: stats?.transactionChange > 0 ? 'increase' : 'decrease',
      icon: 'FileText',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      title: 'Average TRL Score',
      value: `${stats?.averageTRL}%`,
      change: stats?.trlChange,
      changeType: stats?.trlChange > 0 ? 'increase' : 'decrease',
      icon: 'BarChart3',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      title: 'Active Stakeholders',
      value: stats?.activeStakeholders,
      change: stats?.stakeholderChange,
      changeType: stats?.stakeholderChange > 0 ? 'increase' : 'decrease',
      icon: 'Users',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      title: 'Documents Processed',
      value: stats?.documentsProcessed,
      change: stats?.documentChange,
      changeType: stats?.documentChange > 0 ? 'increase' : 'decrease',
      icon: 'FolderOpen',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      title: 'Blockchain Verifications',
      value: stats?.blockchainVerifications,
      change: stats?.blockchainChange,
      changeType: stats?.blockchainChange > 0 ? 'increase' : 'decrease',
      icon: 'Shield',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      title: 'Completion Rate',
      value: `${stats?.completionRate}%`,
      change: stats?.completionChange,
      changeType: stats?.completionChange > 0 ? 'increase' : 'decrease',
      icon: 'TrendingUp',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    }
  ];

  const getChangeIcon = (changeType) => {
    return changeType === 'increase' ? 'TrendingUp' : 'TrendingDown';
  };

  const getChangeColor = (changeType) => {
    return changeType === 'increase' ? 'text-success' : 'text-error';
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6 mb-8">
      {statCards?.map((stat, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-6 shadow-soft hover:shadow-elevated transition-smooth"
        >
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={24} className={stat?.color} />
            </div>
            {stat?.change !== 0 && (
              <div className={`flex items-center space-x-1 ${getChangeColor(stat?.changeType)}`}>
                <Icon name={getChangeIcon(stat?.changeType)} size={16} />
                <span className="text-sm font-medium">
                  {Math.abs(stat?.change)}%
                </span>
              </div>
            )}
          </div>

          <div>
            <h3 className="text-2xl font-bold text-foreground mb-1">
              {stat?.value}
            </h3>
            <p className="text-sm text-muted-foreground">
              {stat?.title}
            </p>
          </div>

          {/* Additional context for specific stats */}
          {stat?.title === 'Average TRL Score' && (
            <div className="mt-3 pt-3 border-t border-border">
              <div className="flex items-center justify-between text-xs text-muted-foreground">
                <span>Target: 85%</span>
                <span className={stats?.averageTRL >= 85 ? 'text-success' : 'text-warning'}>
                  {stats?.averageTRL >= 85 ? 'On Track' : 'Below Target'}
                </span>
              </div>
            </div>
          )}

          {stat?.title === 'Blockchain Verifications' && (
            <div className="mt-3 pt-3 border-t border-border">
              <div className="flex items-center text-xs text-muted-foreground">
                <Icon name="Clock" size={12} className="mr-1" />
                <span>Last: {stats?.lastBlockchainUpdate}</span>
              </div>
            </div>
          )}

          {stat?.title === 'Documents Processed' && (
            <div className="mt-3 pt-3 border-t border-border">
              <div className="flex items-center justify-between text-xs text-muted-foreground">
                <span>This Month</span>
                <span className="font-medium">{stats?.monthlyDocuments}</span>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default DashboardStats;